/**
 * Online Policy "hold until the wallet has money" — the frontend switch. On only when
 * REACT_APP_POLICY_PAYMENT_HOLD_ENABLED is exactly "true" (the tracked .env keeps it "false" for production builds;
 * .env.development.local turns it on for `npm start` — restart it after a change). The backend has its own switch,
 * POLICY_PAYMENT_HOLD_ENABLED. Off = today's page: the "insufficient balance" toast and no Hold option.
 */
export const isPolicyPaymentHoldEnabled = () =>
  String(process.env.REACT_APP_POLICY_PAYMENT_HOLD_ENABLED || "").trim().toLowerCase() === "true";

/** The super admin (a CLIENT login whose roleId is SUPER_ADMIN): cannot create policies, never pays for an edit. */
export const isSuperAdminLogin = () => sessionStorage.getItem("roleId") === "SUPER_ADMIN";
